<template>
  <div id="app">
    <!--提示：成功添加表單-->
    <el-dialog title="提示" :visible.sync="$root.subformDialogVisible">
      <span>您已成功提交联系方式至总览表单，请点击下方‘确认提交’将邮件发送至客服</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="$root.subformDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <!--提示：成功清空表單-->

    <el-dialog title="提示" :visible.sync="$root.clearFormsConetntAlert">
      <center>
        <span>您已经清空表单内容</span>
      </center>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="$root.clearFormsConetntAlert = false">确 定</el-button>
      </span>
    </el-dialog>

    <!--提示：總表單修改子窗--修改-->
    <el-row>
      <el-col :xs="24" :sm="20" :md="12" :lg="12" :xl="12">
        <el-dialog width="80%" title="这些是您准备提交的内容" :visible.sync="$root.dialogVisible">
          <el-dialog
            width="40%"
            title="修改您的內容"
            :visible.sync="$root.dialogSubmitModifier"
            append-to-body
          >
            <el-button
              style="margin:9px"
              size="mini"
              type="primary"
              @click="$root.change($root.willChangeAllFormItemUuid,$root.itemFormData)"
            >确认修改</el-button>
            <el-button
              style="margin:9px"
              size="mini"
              type="danger"
              @click="$root.del($root.willChangeAllFormItemUuid)"
            >删除该项</el-button>
            <el-form ref="itemForm">
              <el-form-item
                v-bind:label="index"
                v-bind:key="index"
                v-for="(item, index) in $root.willChangeAllFormItemObj"
              >
                <el-input
                  v-model="$root.itemFormData[index]"
                  v-if="!Array.isArray(item)&&bindValue(index,item)"
                ></el-input>
                <el-checkbox-group
                  v-model="$root.itemFormData[index]"
                  v-if="Array.isArray(item)&&bindArrayValue(index,item)"
                >
                  <el-checkbox
                    v-bind:label="selectItem"
                    v-bind:key="selectItem"
                    v-for="selectItem in item"
                    name="type"
                  ></el-checkbox>
                </el-checkbox-group>
                <p v-if="Array.isArray(item)">多选框内容暂时不可修改</p>
              </el-form-item>
            </el-form>
          </el-dialog>
          <p>您可以在这核对您需要的信息,有错误您可以直接删除重新提交子表单</p>
          <p>确认后即可提交信息给我们</p>
          <br>
          <el-table :data="$root.gridData">
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button class="my-button" size="mini" type="primary" @click="$root.changeItem(scope.row.hash)">修改</el-button>
                <br>
                <br>
                <el-button class="my-button" size="mini" type="danger" @click="$root.del(scope.row.hash)">删除</el-button>
              </template>
            </el-table-column>
            <el-table-column property="description" label="产品" width="150"></el-table-column>
            <el-table-column property="content" label="表单内容概览"></el-table-column>
          </el-table>
          <br>
          <el-form>
            <!--:model="form"-->
            <el-form-item label="请输入验证码">
              <el-input v-model="$root.captcha.captcha"></el-input>
            </el-form-item>
            <p v-html="captcha.captcha"></p>
            <el-button size="mini" round @click="getCaptcha()">点击获取/更新验证码</el-button>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button style="margin:9px" @click="$root.dialogVisible = false">取消，我去继续添加</el-button>
            <el-button style="margin:9px" type="primary" @click="$root.submit()">确定提交</el-button>
          </span>
        </el-dialog>
      </el-col>
    </el-row>
    <el-container>
      <el-header>
        <el-row class="my-header">
          <el-col :xs="4" :sm="8" :md="8" :lg="10" :xl="10">
            <div>
              <br>
              <hr>
            </div>
          </el-col>
          <el-col :xs="16" :sm="8" :md="8" :lg="4" :xl="4">
            <div>
              <img src="./assets/cvlogo.png">
            </div>
          </el-col>
          <el-col :xs="4" :sm="8" :md="8" :lg="10" :xl="10">
            <div>
              <br>
              <hr>
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-main>
        <el-row type="flex" justify="center">
          <el-col :xs="24" :sm="20" :md="16" :lg="14" :xl="12">
            <!--
            基础信息展示
            -->
            <BasicInfo v-on:basic-infomation-data="basicInfomation = $event"/>
            <!--
            基本服务选择
            -->
            <el-row class="my-middle">
              <el-button
                id="cv-button"
                type="primary"
                v-for="service in services"
                v-bind:key="service.id"
                v-on:click="selectService(service.id)"
                style
              >{{service.name}}</el-button>
            </el-row>
            <el-row class="my-hr">
              <hr>
            </el-row>
            <!--
        【同人收藏本】与【同人周边】
            -->
            <Consignment v-if="services[0].status"/>
            <Agency v-if="services[1].status"/>
            <Consignment v-if="services[2].status"/>
            <Agency v-if="services[2].status"/>
            <PersonalCollection v-if="services[3].status"/>
            <PersonalPeripheral v-if="services[4].status"/>
            <!--<HelloWorld msg="Welcome to Your Vue.js App"/>-->
          </el-col>
        </el-row>
      </el-main>

      <el-footer>
        <el-row
          type="flex"
          class="row-bg my-middle"
          justify="space-between"
          style="padding-top:10%"
        >
          <el-col :xs="1" :sm="6" :md="8" :lg="8" :xl="8"></el-col>
          <el-col :xs="22" :sm="12" :md="8" :lg="8" :xl="8">
            <el-alert title="请在以上子表单填写完毕后点击提交按钮进行检查，确认后即可全部提交" type="info" show-icon></el-alert>
          </el-col>
          <el-col :xs="1" :sm="6" :md="8" :lg="8" :xl="8"></el-col>
        </el-row>

        <el-row type="flex" class="row-bg my-middle" justify="space-between" style="padding-top:6%">
          <el-col :span="24">
            <div class="my-middle">
              <el-button
                style="width:280px;height:80px;"
                @click="$root.openTheSubmitForm()"
                type="primary"
                plain
              >确认提交</el-button>
              <!--<el-button style="width:150px;height:80px;margin-top:10px">提交前检查</el-button>-->
            </div>
          </el-col>
        </el-row>
        <Footer/>
      </el-footer>
    </el-container>

    <div class="gototop hidden-sm-and-down" hidden-sm-and-down>
      <el-button @click="backTop" icon="el-icon-arrow-up" type="primary" plain>返回顶部</el-button>
    </div>
    <div class="goto-mainpage hidden-sm-and-down" hidden-sm-and-down>
      <a href="http://www.comicvalley.cn/">
        <el-button icon="el-icon-location-outline" type="primary" plain>返回首页</el-button>
      </a>
    </div>
    <div class="my-right-submit-button hidden-sm-and-down" hidden-sm-and-down>
      <el-badge
        :value="$root.gridData.length"
        v-if="$root.gridData.length > 0"
        class="item"
        type="primary"
      >
        <el-button icon="el-icon-edit" type="primary" @click="$root.openTheSubmitForm()" plain>待提交項</el-button>
      </el-badge>
    </div>
    <div class="my-customer-service-button hidden-sm-and-down">
      <el-button
        icon="el-icon-service"
        type="primary"
        @click="changeCustomServiceButtonStatus()"
        plain
      >{{customServiceButtonContent}}</el-button>
    </div>
    <transition name="el-fade-in">
      <div class="my-customer-service-button-content-qq hidden-sm-and-down" v-if="customServiceButtonStatus" hidden-sm-and-down>
        <a href="http://wpa.qq.com/msgrd?v=3&uin=800182033&site=qq&menu=yes">
          <el-button type="primary" plain>QQ</el-button>
        </a>
      </div>
    </transition>
    <transition name="el-fade-in">
      <div class="my-customer-service-button-content-email hidden-sm-and-down" v-if="customServiceButtonStatus" hidden-sm-and-down>
        <a href="http://mail.qq.com/cgi-bin/qm_share?t=qm_mailme&email=FiQhICAkJiUlVmdnOHV5ew">
          <el-button type="primary" plain>邮件</el-button>
        </a>
      </div>
    </transition>
    <!--
    <el-card class="box-card right-form-content-card">
      <div slot="header" class="clearfix">
        <span>卡片名称</span>
      </div>
      <div v-for="o in 4" :key="o" class="text item">{{'列表内容 ' + o }}</div>
    </el-card>

    -->
  </div>
</template>

<script>
import BasicInfo from "./components/BasicInfo.vue";
import Agency from "./components/Agency/Agency.vue";
import Footer from "./components/Footer.vue";
import Consignment from "./components/Consignment/Consignment.vue";
import PersonalCollection from "./components/PersonalCollection/PersonalCollection.vue";
import PersonalPeripheral from "./components/PersonalPeripheral/PersonalPeripheral.vue";
import Config from "./Config.vue";
import 'element-ui/lib/theme-chalk/display.css';

export default {
  data() {
    return {
      forcollapse: ["allsame"],
      captcha: {
        captcha: "",
        token: ""
      },
      basicInfomation: {},
      services: [
        { id: 0, name: "寄卖", status: false },
        { id: 1, name: "代印", status: false },
        { id: 2, name: "寄卖+代印", status: false },
        { id: 3, name: "个人志代理", status: false },
        { id: 4, name: "个人周边代理", status: false }
      ],
      product: {
        print: false,
        another: false
      },
      customServiceButtonStatus: false,
      customServiceButtonContent: "联系客服"
    };
  },
  methods: {

    //用於在修改總表單子項綁定遍歷過程傳入值的
    bindValue: function(index, item) {
      try {
        this.$root.itemFormData[index] = item;
        return true;
      } catch {
        return false;
      }
    },
    bindArrayValue: function(index, item) {
      try {
        let itemObj = [];
        for (let i in item) {
          itemObj.push({ name: i, status: true });
        } 
        this.$root.itemFormData[index] = itemObj;
        return true;
      } catch {
        return false;
      }
    },

    backTop: function() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },

    selectService: function(id) {
      for (let i = 0; i < this.services.length; i++) {
        this.services[i].status = false;
      }
      this.services[id].status = true;
    },

    getCaptcha: function() {
      fetch(`${Config.backendBaseUrl}/captcha/create`)
        .then(response => response.json())
        .then(json => {
          this.setCaptchaVarWhenGetCaptchaFinished(json);
        })
        .catch(error => {
          this.getCaptchaErrorHandle(error);
        });
    },
    setCaptchaVarWhenGetCaptchaFinished: function(json) {
      this.captcha = json;
      this.$root.captcha.token = json.token;
      this.$notify({
        title: "已获取验证码",
        dangerouslyUseHTMLString: true,
        message: `请在10小时内完成填写，逾期后验证码将会失效`,
        type: "success"
      });
    },
    getCaptchaErrorHandle: function(error) {
      this.$notify.error({
        title: "错误",
        dangerouslyUseHTMLString: true,
        message: `无法与伺服器取得联系<br>${error}`
      });
    },
    changeCustomServiceButtonStatus: function() {
      if (this.customServiceButtonStatus) {
        this.customServiceButtonStatus = false;
        this.customServiceButtonContent = "联系客服";
      } else {
        this.customServiceButtonStatus = true;
        this.customServiceButtonContent = "点击折叠";
      }
    }
  },
  name: "app",
  components: {
    BasicInfo,
    Agency,
    Footer,
    Consignment,
    PersonalCollection,
    PersonalPeripheral
  },
  provide: function() {
    return {
      getMap: function(myTest) {
        this.allData = myTest;
      }
    };
  }
};
</script>

<style>
.my-header {
  text-align: center;
}
.my-header img {
  width: 200px;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.my-middle {
  text-align: center;
}

.my-service-button {
  height: 300;
  width: 170;
}

.my-hr {
  padding: 3%;
}
.gototop {
  position: fixed;
  bottom: 150px;
  right: 30px;
}
.goto-mainpage {
  position: fixed;
  bottom: 200px;
  right: 30px;
}

.my-right-submit-button {
  position: fixed;
  bottom: 300px;
  right: 30px;
}
.my-customer-service-button {
  position: fixed;
  bottom: 250px;
  right: 30px;
}

.my-customer-service-button-content-qq {
  position: fixed;
  bottom: 250px;
  right: 160px;
}
.my-customer-service-button-content-email {
  position: fixed;
  bottom: 250px;
  right: 230px;
}
/*
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;<i class="el-collapse-item__arrow el-icon-arrow-right is-active"></i>
}*/
i.el-collapse-item__arrow.el-icon-arrow-right.is-active::before {
  content: "闭合";
}
i.el-collapse-item__arrow.el-icon-arrow-right::before {
  content: "展开";
}

* {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
p,
h1,
h2,
h3,
h4,
h5,
h6,
span,
button {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
.el-collapse-item__header::after {
  background: #99a9bf;
}
#cv-button {
  padding: 15px 20px;
  margin: 5px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  border-radius: 5px;
  width: 140px;
  height: 55px;
  margin-top: 10px;
  letter-spacing: 2px;
}
.my-button {
  margin: 8px;
}
</style>
